/* eslint-disable no-param-reassign */
import { createSlice, PayloadAction } from '@reduxjs/toolkit';

import { PagedResultDto } from '@ldx-dmp/Core/models';

import { EquipmentDto } from 'modules/InstrumentsQualityControl/models';

export type EquipmentState = {
  items: PagedResultDto<EquipmentDto>;
  current?: EquipmentDto | null;
  formOpen: boolean;
  loading: 'NONE' | 'IDLE' | 'LOADING' | 'RELOADING';
  summaryType: 'CARD' | 'TABLE';
  addInstrumentsOpen: boolean;
  addControlInstrumentsOpen: boolean;
};

export const initialState: EquipmentState = {
  loading: 'NONE',
  formOpen: false,
  items: new PagedResultDto<EquipmentDto>(),
  summaryType: 'TABLE',
  addInstrumentsOpen: false,
  addControlInstrumentsOpen: false,
};

export const slice = createSlice({
  name: 'equipment',
  initialState,
  reducers: {
    setData: (state, action: PayloadAction<PagedResultDto<EquipmentDto>>) => {
      state.items = action.payload;
    },
    openForm: state => {
      state.formOpen = true;
    },
    closeForm: state => {
      state.formOpen = false;
    },
    setCurrent: (state, action: PayloadAction<EquipmentDto | null>) => {
      state.current = action.payload;
    },
    startLoading: state => {
      state.loading = state.loading === 'NONE' ? 'LOADING' : 'RELOADING';
    },
    stopLoading: state => {
      state.loading = state.loading === 'NONE' ? 'NONE' : 'IDLE';
    },
  },
});

export const {
  setData,
  openForm,
  closeForm,
  startLoading,
  stopLoading,
  setCurrent,
} = slice.actions;

export const selectFormOpen = (state: EquipmentState) => state.formOpen;
export const selectItems = (state: EquipmentState) => state.items;
export const selectLoading = (state: EquipmentState) => state.loading;
export const selectCurrent = (state: EquipmentState) => state.current;

export default slice.reducer;
